/* import __COLOCATED_TEMPLATE__ from './ipsum-text.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();